var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEarn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 101,
    viewBox: "0 0 95 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.2223 66.2955C62.9981 74.8728 54.8613 80.7033 46.8326 83.2674C38.8025 85.832 31.0593 85.0958 25.2508 80.8808C19.4423 76.6658 16.3411 69.5326 16.289 61.1031C16.2369 52.675 19.2567 43.1313 25.4809 34.554C31.7051 25.9767 39.8418 20.1462 47.8706 17.5821C55.9007 15.0175 63.6438 15.7537 69.4524 19.9687C75.2609 24.1837 78.3621 31.3169 78.4142 39.7464C78.4663 48.1745 75.4465 57.7182 69.2223 66.2955Z",
    fill: "#33D9FF",
    fillOpacity: 0.05,
    stroke: "url(#paint0_linear_1_1866)",
    strokeWidth: 4.84
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_1866)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.0546 41.3003C66.0469 41.2931 66.0386 41.2862 66.0297 41.2799L60.9716 37.6456C60.7463 37.4836 60.3722 37.4817 59.9954 37.6404C59.6187 37.799 59.2921 38.096 59.1432 38.4154L55.7926 45.6008L47.6506 49.4057L43.0571 45.6008L46.4077 38.4154C46.5566 38.096 46.5071 37.799 46.2782 37.6404C46.0494 37.4817 45.6734 37.4836 45.2973 37.6456L36.8501 41.2799C36.8353 41.2864 36.8207 41.293 36.8064 41.3001C36.4533 41.4638 36.1508 41.7476 36.0099 42.0498L28.1553 58.8941C28.0145 59.1961 28.0523 59.4798 28.2524 59.6434C28.2601 59.6506 28.2685 59.6574 28.2773 59.6638L33.3352 63.2981C33.4473 63.3786 33.5983 63.4213 33.772 63.4213C33.9418 63.4213 34.1283 63.3805 34.3114 63.3033C34.6882 63.1447 35.0147 62.8477 35.1636 62.5283L38.5142 55.3429L46.6562 51.5382L51.2498 55.3429L47.8992 62.5283C47.7502 62.8477 47.7998 63.1447 48.0286 63.3033C48.1399 63.3805 48.2884 63.4213 48.458 63.4213C48.6315 63.4213 48.8223 63.3788 49.0095 63.2981L57.457 59.6638C57.4717 59.6575 57.4863 59.6507 57.5007 59.6434C57.8536 59.4798 58.1562 59.1961 58.2971 58.8939L66.1516 42.0498C66.2925 41.7476 66.2547 41.4639 66.0546 41.3003ZM58.2863 44.4356L60.3659 39.976L63.3071 42.0894L58.2863 44.4356ZM53.6513 54.3755L57.292 46.568L63.4324 43.6986L57.1156 57.2449L53.6513 54.3755ZM55.4895 58.8543L50.5773 60.9677L52.6568 56.5083L55.4895 58.8543ZM54.7984 47.7334L52.2444 53.2104L48.9381 50.4719L54.7984 47.7334ZM45.369 50.4719L39.5087 53.2104L42.0626 47.7334L45.369 50.4719ZM40.6556 46.568L37.0148 54.3757L30.8746 57.2451L37.1915 43.6986L40.6556 46.568ZM38.8175 42.0894L43.7295 39.9762L41.65 44.4356L38.8175 42.0894ZM36.0205 56.5081L33.941 60.9675L30.9999 58.8543L36.0205 56.5081Z",
    fill: "url(#paint1_linear_1_1866)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_1866",
    x: 26.135,
    y: 37.5227,
    width: 42.0369,
    height: 29.7707,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.936
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.968
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_1866"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_1866",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_1866",
    x1: 23.8295,
    y1: 82.8394,
    x2: 23.1529,
    y2: 10.0322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#33D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.548077,
    stopColor: "#2988F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.817308,
    stopColor: "#33D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33D9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_1866",
    x1: 62.2243,
    y1: 50.472,
    x2: 37.4661,
    y2: 38.927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#33D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461538,
    stopColor: "#2988F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.774038,
    stopColor: "#33D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33D9FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarn);
export default __webpack_public_path__ + "static/media/earn.5ae6b8054b14b191b8eed7f9d6bb5da7.svg";
export { ForwardRef as ReactComponent };